import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    directoryNav: {
        accessibility: string;
        hide: string;
        show: string;
    };
    directoryContent: {
        accessibility: string;
        hide: string;
        show: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            directoryNav: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "trash.directoryNav.accessibility?c=1bazrwnmy8ccb", defaultMessage: "Toggle the Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "trash.directoryNav.hide?c=lntz05bdbtl4", defaultMessage: "Hide Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "trash.directoryNav.show?c=9rg4whmyumvu", defaultMessage: "Show Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            directoryContent: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "trash.directoryContent.accessibility?c=67gi9oyyra8t", defaultMessage: "Toggle the Deleted Assets view" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "trash.directoryContent.hide?c=2kqh0c6y30xa0", defaultMessage: "Hide the Deleted Assets view" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "trash.directoryContent.show?c=3alcssskibttl", defaultMessage: "Show the Deleted Assets view" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
